<template>
  <AppBarLayout>
    <div
      class="tw-w-[100%] tw-h-[100%] tw-overflow-y-auto box-shadow-contain"
      style="background: rgba(239, 240, 241, 0.5)"
    >
      <ActivePathWrapper
        :active-hierarchy="[
          getComponentUiText('app-menu-assess-1'),
          getComponentUiText('app-menu-submenu-assess-vendor-assessments-1'),
          getComponentUiText('app-component-vendor-assessment-review-title-1'),
          checklistRequestedData.name ?? '',
        ]"
        :button-title="
          getComponentUiText(
            'app-menu-submenu-assess-vendor-assessments-save-vs-close-button-title-1',
          )
        "
        :button2-title="
          checklistRequestedData.statusId === CHECKLISTSTATUS.DONE
            ? ''
            : getComponentUiText(
                'app-component-vendor-assessment-review-resend-button-1',
              )
        "
        :button3-title="
          checklistRequestedData.statusId === CHECKLISTSTATUS.DONE
            ? ''
            : getComponentUiText(
                'app-component-vendor-assessment-review-complete-button-1',
              )
        "
        :is-outline="true"
        :is-button2-enable="false"
        :is-button3-enable="false"
        :navigate="['', '/assess/vendor/manage', '', '']"
        id-button1="vendor-assess-review-btn-save"
        id-button2="vendor-assess-review-btn-submit"
        id-button3="vendor-assess-review-btn-mark-complete"
        data-cy1="vendor-assess-review-btn-save"
        data-cy2="vendor-assess-review-btn-submit"
        :is-btn-loading="isBtnLoading"
        :is-btn2-loading="isBtn2Loading"
        :is-btn3-loading="isBtn3Loading"
        @click-button="handleSaveAndClose"
        @click-button2="handleResendButton"
        @click-button3="handleCompleteButton"
      />
      <div
        id="vendor-assessment-review-section-1"
        class="tw-bg-[white] xl:tw-pt-[50px] xl:tw-pb-[55px] xl:tw-px-[60px] tw-p-[20px]"
      >
        <div
          class="tw-w-full tw-items-center tw-flex tw-justify-between tw-mb-[20px]"
        >
          <div class="tw-flex tw-items-center tw-mr-2">
            <span class="tw-text-[32px] tw-font-[600] tw-text-[#211F58] tw-pr-2"
              >{{
                getComponentUiText(
                  "app-component-vendor-assessment-review-assessment-title-1",
                )
              }}:
            </span>
            <input
              v-if="isUpdateAssessmentName"
              id="input-rename"
              v-model="assessmentName"
              type="text"
              class="tw-rounded-md tw-w-[200px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-py-[5px] tw-px-[10px] tw-text-[15px] tw-font-[400] tw-text-[#211F58] tw-mr-2"
              @keyup.enter="onRenameAssessment"
              @blur="onRenameAssessment"
            />
            <span
              v-if="!isUpdateAssessmentName"
              id="vendor-assess-review-assessment-name"
              data-cy="vendor-assess-review-assessment-name"
              class="tw-text-[32px] tw-font-[400] tw-text-[#211F58]"
            >
              {{ assessmentName }}
            </span>
          </div>
          <div
            id="popover-vendor-assessments-review-header-option-wrap"
            class="tw-w-[46px] tw-h-[44px] tw-items-center tw-flex tw-justify-center"
            style="
              border-radius: 6px;
              border: 1px solid var(--UI-rule, #eff0f1);
              background: var(--UI-white, #fff);
              box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
            "
          >
            <PopoverAssessment
              ref="popoverAssessmentContentRef"
              id-popover="popover-vendor-assessments-review-header-option"
              padding="14px 13px"
              style-button="tw-w-[61px] tw-items-center tw-justify-center"
              class="tw-h-[56px]"
              :offset="0"
            >
              <CustomDropDownItem
                v-for="(item, index) in subMenuOptions"
                :id="`popover-create-template-item-${index}`"
                :key="`option_vendor_assessment_review_${index}`"
                :is-show-option="item.isShow"
                :id-text="`${item.text}`"
                :custom-text-class="`tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                  item.arrowRed ? 'tw-text-[#F7553C]' : ''
                } tw-whitespace-normal`"
                :arrow-icon-style="`${
                  item.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
                } tw-min-w-[7px]`"
                :padding="'tw-px-[13px] tw-py-[12px]'"
                :custom-class="'tw-flex tw-justify-between tw-items-center !tw-border-0'"
                @click="() => item.action()"
              />
            </PopoverAssessment>
          </div>
        </div>

        <div
          v-if="checklistRequestedData.descInternal"
          id="vendor-assess-review-internal-description"
          class="tw-bg-[#F2F8FF] tw-p-[20px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px] tw-mb-[20px]"
        >
          <span class="tw-text-[15px] tw-font-400 tw-text-[#231F20]">{{
            checklistRequestedData.descInternal
          }}</span>
        </div>
        <div class="vendor-card-container tw-grid tw-grid-cols-3 tw-gap-[20px]">
          <div
            id="vendor-assess-review-status"
            class="vendor-card tw-col-span-3 xl:tw-col-span-1"
          >
            <StatusCard
              :is-show-tag="true"
              :is-show-vendor-assessment-tag="true"
              :status="vendorStatus"
              :sub-text1="
                getComponentUiText(
                  'app-component-vendor-assessments-status-card-answered-1',
                )
              "
              :sub-text2="
                getComponentUiText(
                  'app-component-vendor-assessments-status-card-reviewed-1',
                )
              "
              :is-loading="isLoadingRequestedItem"
              :is-show-complete-score="false"
              class="!tw-h-[119px]"
            />
          </div>
          <div
            id="vendor-assess-review-card"
            class="vendor-card tw-col-span-3 xl:tw-col-span-1"
          >
            <VendorCard
              :vendor="vendor"
              :is-loading="isLoadingRequestedItem"
              class="!tw-h-[119px]"
            />
          </div>
          <div
            id="vendor-assess-review-result"
            class="vendor-card tw-col-span-3 xl:tw-col-span-1"
          >
            <AssessmentResultCard
              :data="results"
              :is-loading="isLoadingRequestedItem"
              :status="checklistRequestedDetailItem.statusId"
              :is-vendor-assessment="true"
              class="!tw-h-[119px]"
            />
          </div>
          <div
            v-if="!isLoadingHeading && checklistRequestedData.notesInternal"
            id="vendor-assess-review-internal-notes"
            class="tw-bg-[#FCFCFD] tw-p-4 tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px] tw-col-span-3"
          >
            <p
              class="tw-text-[#211F58] tw-text-[15px] tw-font-[600] tw-leading-[130%]"
            >
              {{
                getComponentUiText(
                  "app-component-assessments-instructions-title-1",
                )
              }}
            </p>
            <p class="tw-text-[#231F20] tw-text-[15px] tw-font-[400]">
              {{ checklistRequestedData.notesInternal }}
            </p>
          </div>
        </div>
      </div>
      <VendorAssessmentReviewQuestion
        :checklist-data="checklistRequestedData"
        :requested-id-valid-success="requestedIdValidSuccess"
        @close-page="closePage"
      />
    </div>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import { downloadCSV, getComponentUiText, hasValue } from "@/utils/utilities";
import VendorCard from "@/components/assessments/vendorCard.vue";
import StatusCard from "@/components/assessments/statusCard.vue";
import PopoverAssessment from "@/components/assessment/popoverAssessment.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import AssessmentResultCard from "@/components/assessments/assessmentResultsCard.vue";
import VendorAssessmentReviewQuestion from "@/components/vendor/vendorAssessmentReviewQuestion.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import {
  computed,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  watch,
} from "vue";
import {
  getAssessmentItemsCSV,
  getChecklistRequested,
} from "@/services/assessment";
import {
  assessmentStatus,
  checklistRequestedStatusId,
  CHECKLISTSTATUS,
  MODAL_NAME,
  routers,
  successStatusCodes,
} from "@/utils/constants";
import { IChecklistRequested, IDataEmailGrant } from "@/interfaces/vendor";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import {
  postChecklistResendVendor,
  putChecklistRequested,
} from "@/services/vendor";
import { Checklist, Vendor } from "@/services/apiRoutes/routes";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import router from "@/router";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { get } from "lodash";
import dayjs from "dayjs";
import eventEmitter from "@/utils/eventEmitter";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";

const route = useRoute();
const id = Number(route.params.assessmentId);
const checklistRequestedData = reactive<IChecklistRequested>({
  checklistRequestedId: 0,
  orgId: "",
  orgName: "",
  providerId: 0,
  providerName: "",
  name: "",
  expiryDate: "",
  descInternal: "",
  descExternal: "",
  notesInternal: "",
  notesExternal: "",
  notesResponse: null,
  responsesValidFrom: "",
  responsesValidUntil: null,
  dateAdded: "",
  addedByUserId: "",
  dateUpdated: null,
  updatedByUserId: null,
  dateUpdatedEmailGrant: null,
  updatedByEmailGrantId: null,
  isArchived: false,
  checklistRequestedToStatusId: 0,
  statusId: "",
  status: "",
  statusAsAtDate: "",
  statusAddedByUserId: null,
  statusEmailGrantId: 0,
  statusNotes: null,
  itemCount: 0,
  completion: 0,
  completionMax: 0,
  completionPcnt: 0,
  completionOrg: 0,
  completionOrgMax: 0,
  completionOrgPcnt: 0,
  score: 0,
  scoreMax: 0,
  scorePcnt: 0,
  scoreGap: 0,
  checklistName: "",
  checklistId: 0,
});

const resendVendorModal = {
  show: false,
  title: getComponentUiText(
    "app-component-vendor-assessment-review-modal-resend-vendor-title-1",
  ),
  description: getComponentUiText(
    "app-component-vendor-assessment-review-modal-resend-vendor-description-1",
  ),
  buttonRed: false,
  buttonText: getComponentUiText(
    "app-component-vendor-assessment-review-modal-resend-vendor-resend-button-1",
  ),
  styleClass: { background: "rgba(0, 0, 0, 0.5)" },
};

const isLoadingHeading = ref(false);
const isBtnLoading = ref(false);
const isBtn2Loading = ref(false);
const isBtn3Loading = ref(false);
const vendorStatus: any = reactive({
  statusCode: "Created",
  statusId: "new",
  completedSteps: 0,
  progress: {
    completed: 50,
    total: 100,
    percent: 50,
  },
  score: {
    completed: 50,
    total: 100,
    percent: 50,
  },
});
const SUB_MENU_OPTIONS = {
  RENAME: "Rename",
  CHANGE_RECIPIENT: "Change Recipient",
  SET_IN_PROGRESS: "Set In Progress",
  DOWNLOAD_ASSESSMENT: "Download Assessment (CSV)",
};
const isUpdateAssessmentName: Ref<boolean> = ref(false);
const assessmentName = ref(checklistRequestedData.name);
const popoverAssessmentContentRef: Ref = ref(false);
const isCallApiUpdate = ref(false);
const isShowExternalDetails = ref(false);

interface Option {
  id: number;
  name?: string;
  text: string;
  arrowRed: boolean;
  isShow: boolean;
  action: () => void;
}
const subMenuOptions: Ref<Option[]> = ref([
  {
    id: 1,
    text: "app-vendor-assessment-manage-submenu-restore-assessment-option-1",
    arrowRed: false,
    isShow: checklistRequestedData.isArchived === true,
    action: () => handleRestoreAssessment(),
  },
  {
    id: 2,
    name: SUB_MENU_OPTIONS.RENAME,
    text: "app-vendor-assessment-manage-submenu-rename-assessment-option-1",
    arrowRed: false,
    isShow: checklistRequestedData.isArchived === false,
    action: () => handleRenameAssessment(),
  },
  {
    id: 3,
    name: SUB_MENU_OPTIONS.CHANGE_RECIPIENT,
    text: "app-vendor-assessment-manage-submenu-change-recipient-option-1",
    arrowRed: false,
    isShow: checklistRequestedData.isArchived === false,
    action: () => handleChangeRecipientAction(checklistRequestedData),
  },
  // {
  //   id: 4,
  //   name: SUB_MENU_OPTIONS.SET_IN_PROGRESS,
  //   textId: "app-vendor-assessment-manage-submenu-set-inprogress-option-1",
  //   isShow: true,
  //   action: (item) => handleSetAssessmentInProgressAction(item),
  // },
  {
    id: 5,
    name: SUB_MENU_OPTIONS.DOWNLOAD_ASSESSMENT,
    text: "app-vendor-assessment-manage-submenu-download-assessment-option-1",
    arrowRed: false,
    isShow: checklistRequestedData.isArchived === false,
    action: () => handleDownloadAssessment(checklistRequestedData),
  },
  {
    id: 6,
    text: "app-component-vendor-assessment-review-meatball-item-external-details-1",
    arrowRed: false,
    isShow:
      checklistRequestedData.isArchived === false &&
      isShowExternalDetails.value,
    action: () => showExternalDetails(),
  },
  {
    id: 7,
    text: "app-vendor-assessment-btn-delete-assessment-1",
    arrowRed: true,
    isShow: checklistRequestedData.isArchived === false,
    action: () => handleDeleteAssessment(),
  },
]);
const isLoadingRequestedItem = computed(
  () => store.state.Vendor.isLoadingRequestedItem,
);
const requestedDetail = computed(() => store.state.Vendor.requestedDetailItem);
const checklistRequestedDetailItem = computed(() => {
  if (!store.state.Vendor.requestedDetailItem?.checklistsRequested) return [];
  const data =
    store.state.Vendor.requestedDetailItem?.checklistsRequested[0] ?? [];
  return data;
});
const dataEmailGrants = ref([] as IDataEmailGrant[]);

const vendor = reactive({
  name: "",
  recipient: "",
  expiryDate: "",
  recipientFirstName: "",
  recipientLastName: "",
});

const requestedIdValidSuccess: any = ref({});

onMounted(() => init());

const init = async () => {
  eventEmitter.on(EmitterEvents.VENDOR_ITEM_VALID_SUCCESS, (data: any) => {
    requestedIdValidSuccess.value = {
      ...requestedIdValidSuccess.value,
      [data.checklistItemId]: data?.isValid,
    };
  });
  eventEmitter.on(EmitterEvents.VENDOR_ITEM_INVALID, () => {
    isBtnLoading.value = false;
  });
  isLoadingHeading.value = true;

  getDataItems();
  await Promise.all([getChecklistStatusDetail(id), fetchDataEmailGrants(id)]);
  isBtnLoading.value = false;
};

onUnmounted(() => {
  eventEmitter.off(EmitterEvents.VENDOR_ITEM_VALID_SUCCESS);
  eventEmitter.off(EmitterEvents.VENDOR_ITEM_INVALID);
});

const checkExternalDetails = () => {
  if (
    !checklistRequestedData.notesExternal &&
    !checklistRequestedData.descExternal
  ) {
    isShowExternalDetails.value = false;
  } else {
    isShowExternalDetails.value = true;
  }
};
watch(
  () => checklistRequestedData,
  (value) => {
    if (value) {
      checkExternalDetails();
      const option = subMenuOptions.value.find(
        (option) => option.name === SUB_MENU_OPTIONS.SET_IN_PROGRESS,
      );
      if (option) {
        option.isShow =
          value.statusId !== checklistRequestedStatusId.inProgress;
      }
    }
  },
  { deep: true },
);
const getChecklistStatusDetail = async (checklistRequestedId: number) => {
  try {
    const res: any = await getChecklistRequested(checklistRequestedId);
    if (res.status === successStatusCodes.OK) {
      Object.assign(checklistRequestedData, res.data.data);
      vendorStatus.statusCode = res.data.data.status;
      vendorStatus.statusId = res.data.data.statusId;
      assessmentName.value = res.data.data.name;
    }
  } catch (error) {
    showErrorAPI(error, Checklist.getChecklistRequested);
  }
};

const results: any = reactive({
  evaluated: {
    completed: 18,
    total: 200,
    percent: 9,
  },
  results: {
    completed: 18,
    total: 200,
    percent: 9,
  },
});

const getDataItems = () => {
  const requestedId = route.params.assessmentId;
  if (!requestedId) {
    return;
  }
  store.dispatch("Vendor/fetchRequestedDetailItems", { requestedId });
  store.dispatch("Assessment/fetchAssessmentQuestionTypes", "clra");
};

const showExternalDetails = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_VENDOR_UPDATE_ASSESSMENT_DETAIL,
    properties: {
      checklistAssessmentData: checklistRequestedData,
    },
    events: {
      "update:data": () => {},
    },
  };

  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const items = [
  {
    text: getComponentUiText(
      "app-component-vendor-assessment-review-meatball-item-external-details-1",
    ),
    arrowRed: false,
    status: false,
    action: showExternalDetails,
  },
];

const checkActivePopover = () => {
  return !items.some((item) => item.status);
};

const handleSaveAndClose = async () => {
  isBtnLoading.value = true;
  requestedIdValidSuccess.value = [];
  EventEmitter.emit(EmitterEvents.SAVE_AND_CLOSE_REVIEW_VENDOR);
};

const closePage = () => {
  if (store.state.Vendor.isUpdateRequestedItemsDone) {
    showToastSuccess(
      getComponentUiText(
        "app-component-vendor-assessment-review-update-checklist-success-message-1",
      ),
    );
    router.push({ path: routers.assessVendor });
  } else {
    router.push({ path: routers.assessVendor });
  }
};

const handleResendButton = () => {
  const emitData = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: resendVendorModal.title,
      description: resendVendorModal.description,
      buttonRed: resendVendorModal.buttonRed,
      buttonText: resendVendorModal.buttonText,
      styleClass: resendVendorModal.styleClass,
      additionalNote: " ",
    },
    events: {
      "update:data": handleResendVendor,
      "update:close": () => (resendVendorModal.show = false),
    },
  };

  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleResendVendor = async () => {
  if (isBtn2Loading.value) return;
  isBtn2Loading.value = true;
  try {
    const emailGrandIds = get(
      store.state.Vendor,
      "requestedDetailItem.checklistsRequested[0].checklistRequestedEmailGrants",
      [],
    );

    if (emailGrandIds === null || emailGrandIds.length === 0) return;
    const emailGrandId = emailGrandIds[0].emailGrantId;
    const res = await postChecklistResendVendor(id, emailGrandId);
    if (res.status !== successStatusCodes.OK) {
      showError(
        getComponentUiText(
          "app-component-vendor-assessment-review-modal-resend-vendor-failed-message-1",
        ),
      );
      return;
    }

    showToastSuccess(
      getComponentUiText(
        "app-component-vendor-assessment-review-modal-resend-vendor-success-message-1",
      ),
    );

    router.push({ path: routers.assessVendor });
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedDetailItem);
  } finally {
    isBtn2Loading.value = false;
    resendVendorModal.show = false;
  }
};

const showToastSuccess = (message) => {
  const emitData: IToastMessage = { variant: ToastVariant.SUCCESS, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const getLatestDate = (item) => {
  const dateAdded = new Date(item.dateAdded);
  const dateUpdated = item.dateUpdated ? new Date(item.dateUpdated) : null;
  return dateUpdated && dateUpdated > dateAdded ? dateUpdated : dateAdded;
};
watch(
  () => checklistRequestedDetailItem.value,
  (value) => {
    if (value) {
      if (value.checklistRequestedEmailGrants.length === 0) {
        vendor.recipient = "";
        vendor.expiryDate = "";
        vendor.recipientFirstName = "";
        vendor.recipientLastName = "";
      } else {
        const filterItem = value.checklistRequestedEmailGrants.filter(
          (item) => item.isArchived === false,
        );
        const checklistRequestedEmailGrantLast = filterItem.length
          ? filterItem.reduce((prev, current) => {
              const maxDate = getLatestDate(prev);
              const currentDate = getLatestDate(current);
              return currentDate > maxDate ? current : prev;
            })
          : null;
        vendor.name =
          value.providerName ||
          value.providerService ||
          checklistRequestedEmailGrantLast?.orgName ||
          "-";
        vendor.recipient = checklistRequestedEmailGrantLast?.recipientEmail;
        vendor.expiryDate = checklistRequestedEmailGrantLast?.validUntil;
        vendor.recipientFirstName = checklistRequestedEmailGrantLast?.firstName;
        vendor.recipientLastName = checklistRequestedEmailGrantLast?.lastName;
      }

      // Status
      vendorStatus.progress.completed = value.completion;
      vendorStatus.progress.total = value.itemCountApplicable;
      vendorStatus.progress.percent = (value.completionPcnt * 100).toFixed(0);
      vendorStatus.score.completed = value.score;
      vendorStatus.score.total = value.itemCount;
      vendorStatus.score.percent = (value.scorePcnt * 100).toFixed(0);
      vendorStatus.completedSteps = (value.scorePcnt * 100).toFixed(0);

      // AssessmentResultCard
      const totalPassedReview = value.checklistRequestedItems.filter(
        (item) => item.checklistItemComplianceTypeValueOrgId === 81,
      ).length;

      results.evaluated.completed = totalPassedReview;
      results.evaluated.total = value.completionOrgMax;
      results.evaluated.percent = (
        (totalPassedReview / value.completionOrgMax) *
        100
      ).toFixed();
      results.results.completed = value.score;
      results.results.total = value.scoreMax;
      results.results.percent = (value.scorePcnt * 100).toFixed();
    }
  },
);

const handleRenameAssessment = async () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  isUpdateAssessmentName.value = true;

  setTimeout(() => {
    document.getElementById("input-rename")?.focus();
  }, 300);
};

const onRenameAssessment = async () => {
  isUpdateAssessmentName.value = false;
  if (isCallApiUpdate.value) return;

  isCallApiUpdate.value = true;
  try {
    const res = await putChecklistRequested({
      checklistRequestedId: checklistRequestedData.checklistRequestedId,
      params: {
        checklistRequestedName: assessmentName.value,
      },
    });
    checklistRequestedData.name = assessmentName.value;
    if (!res) {
      assessmentName.value = checklistRequestedData.name;
    }
    setTimeout(() => {
      isCallApiUpdate.value = false;
    }, 100);
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};
const fetchDataEmailGrants = async (checklistRequestedId: number) => {
  const dataEmailGrant = await store.dispatch(
    "Vendor/fetchChecklistRequestedEmailGrants",
    checklistRequestedId,
  );
  dataEmailGrants.value = dataEmailGrant?.emailGrants || [];
};

const handleChangeRecipientAction = (item) => {
  const newData = requestedDetail.value.checklistsRequested[0];
  const dataEmailGrant = item.dataEmailGrant;
  const properties = {
    checklistRequestedId: item.checklistRequestedId,
    emailGrantId: dataEmailGrant
      ? item.dataEmailGrant.emailGrantId
      : item.emailGrantId,
    providerId: item.providerId,
    offererOrgName: dataEmailGrant ? item.dataEmailGrant.orgName : "",
    recipientEmail: dataEmailGrant ? item.dataEmailGrant.recipientEmail : "",
    validFrom: dataEmailGrant ? item.dataEmailGrant.validFrom : "",
    validUntil: dataEmailGrant ? item.dataEmailGrant.validUntil : "",
    checklistRequestedName: item.name,
    dataEmailGrants: dataEmailGrants.value,
    templateId: dataEmailGrant
      ? item.dataEmailGrant.templateId
      : item.templateId,
    dataItem: newData,
    isReviewPage: true,
  };
  const emitData = {
    component: MODAL_NAME.MODAL_VENDOR_EDIT_ASSESSMENT_DETAIL,
    properties,
    events: {
      "update:data": () => {
        getDataItems();
        getChecklistStatusDetail(id);
        fetchDataEmailGrants(checklistRequestedData.checklistRequestedId);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  popoverAssessmentContentRef.value.popoverShow = false;
};

const handleSetAssessmentInProgressAction = async (item) => {
  const params = {
    providerId: item.providerId,
    checklistRequestedId: item.checklistRequestedId,
  };
  const body = {
    checklistRequestedStatusId: checklistRequestedStatusId.inProgress,
  };
  const optionIndex = subMenuOptions.value.findIndex(
    (option) => option.id === 3,
  );
  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
    });
    popoverAssessmentContentRef.value.popoverShow = false;
    subMenuOptions.value[optionIndex].isShow = false;
    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-inprogress-success-1",
      ),
    );
    vendorStatus.statusCode = assessmentStatus.inProg;
    vendorStatus.statusId = checklistRequestedStatusId.inProgress;
  } catch (error: any) {
    subMenuOptions.value[optionIndex].isShow = true;
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

const handleDeleteAssessment = async () => {
  try {
    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: true,
      },
      checklistRequestedId: checklistRequestedData.checklistRequestedId,
    });
    if (res) {
      showSuccessToast(
        getComponentUiText("app-vendor-assessment-delete-assessment-success-1"),
      );
      router.go(-1);
    }
    popoverAssessmentContentRef.value.popoverShow = false;
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const handleDownloadAssessment = async (item) => {
  try {
    const res = await getAssessmentItemsCSV(
      checklistRequestedData.checklistRequestedId,
    );
    downloadCSV(
      res,
      `CyberSystem_Assessment_Export_${dayjs().format("YYYYMMDD_HHmmss")}_${
        assessmentName.value
      }.csv`,
    );
    if (res) {
      showSuccessToast(
        getComponentUiText(
          "app-vendor-assessment-download-assessment-success-1",
        ),
      );
    }
    popoverAssessmentContentRef.value.popoverShow = false;
  } catch (error) {
    showErrorAPI(error, Checklist.getAssessmentItemsCSV);
  }
};

const handleRestoreAssessment = async () => {
  try {
    popoverAssessmentContentRef.value.popoverShow = false;

    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: false,
      },
      checklistRequestedId: checklistRequestedData.checklistRequestedId,
    });

    if (!res) return;

    showSuccessToast(
      getComponentUiText("app-vendor-assessment-restore-assessment-success-1"),
    );

    router.go(-1);
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const handleCompleteButton = async () => {
  if (isBtn3Loading.value) return;
  isBtn3Loading.value = true;

  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.DONE };
  const params = {
    checklistRequestedId: checklistRequestedData.checklistRequestedId,
  };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-complete-success-1",
      ),
    );

    init();
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  } finally {
    isBtn3Loading.value = false;
  }
};
</script>

<style lang="scss" scoped>
.box-shadow-contain {
  box-shadow: 2px 0px 20px 0px rgba(33, 31, 88, 0.1);
}
.vendor-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(335px, 1fr));
}
.content__settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Poppins;
  line-height: 135%;
  cursor: pointer;
}
</style>
